import { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { Courier } from 'core/graphql/types';
import useCountryContext from 'core/hooks/useCountryContext';
import {
  CouriersLastPositionsRequest,
  CourierPosition,
} from '../grpc/trafficUpdates_pb';
import { TrafficUpdatesGrpcServiceClient } from '../grpc/TrafficUpdatesServiceClientPb';

type LastCouriersPositionsResult = {
  couriersLastPositions: CourierPosition[];
};

function useLastCouriersPositionsDataStore(
  agencyCouriers: Courier[],
  client: TrafficUpdatesGrpcServiceClient,
): LastCouriersPositionsResult {
  const [couriersLastPositions, setCouriersLastPositions] = useState<
    CourierPosition[]
  >([]);
  const courierIds = agencyCouriers.map((x) => x.courierId);
  const auth = useAuth();
  const token = auth.user?.access_token;
  const { countryContext } = useCountryContext();

  useEffect(() => {
    if (agencyCouriers === undefined || agencyCouriers.length === 0) {
      return () => {};
    }

    const request = new CouriersLastPositionsRequest();
    request.setCourierIdsList(courierIds);
    request.setCountryCode(countryContext?.toString() ?? '');
    const deadlineInMs = 5000;

    const courierLocationStream = client.streamFromServerCouriersLastPositions(
      request,
      {
        Authorization: `Bearer ${token}`,
        deadline: deadlineInMs.toString(),
      },
    );

    courierLocationStream.on('data', (response) => {
      setCouriersLastPositions(response.getCouriersPositionsList());
    });

    courierLocationStream.on('error', (error) => {
      console.log(
        `Server streaming has following error message: ${error.message} and error code: ${error.code}`,
      );
    });

    courierLocationStream.on('end', () => {
      console.log('Server ended streaming.');
    });

    return () => {
      if (courierLocationStream) {
        courierLocationStream.cancel();
        console.log('Streaming cancelled');
      }
    };
  }, [agencyCouriers, token]);

  return {
    couriersLastPositions,
  };
}

export default useLastCouriersPositionsDataStore;
